var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fill: "var(--color-secondary)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.475 15.076a.61.61 0 00-.62.598v5.307c-.001.99-.834 1.792-1.86 1.793h-17.4c-1.027 0-1.859-.803-1.86-1.793V5.405c.001-.99.833-1.792 1.86-1.793h5.506a.61.61 0 00.62-.598.61.61 0 00-.62-.597H3.595c-1.711 0-3.098 1.338-3.1 2.988v15.576c.002 1.65 1.389 2.987 3.1 2.99h17.4c1.711-.003 3.098-1.34 3.1-2.99v-5.307a.61.61 0 00-.62-.598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85.878a2.865 2.865 0 00-3.947 0L8.84 11.542a.593.593 0 00-.159.263l-1.455 5.063a.58.58 0 00.16.582.634.634 0 00.603.154l5.252-1.403a.626.626 0 00.273-.153L24.577 5.384a2.624 2.624 0 000-3.804L23.85.878zM10.19 11.931l9.054-8.728 2.92 2.815-9.054 8.727-2.92-2.814zm-.583 1.128l2.333 2.249-3.227.862.894-3.111zM23.7 4.539l-.657.633-2.92-2.814.657-.634a1.592 1.592 0 012.192 0l.728.701c.605.584.605 1.53 0 2.114z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.495)",
    d: "M0 0h24.898v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.0fa6ca633bd16c547f3611765ef7b68f.svg";
export { ForwardRef as ReactComponent };